import { render } from "./BasketballJersey_7_back.vue?vue&type=template&id=09a440e0"
import script from "./BasketballJersey_7_back.vue?vue&type=script&lang=js"
export * from "./BasketballJersey_7_back.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__